import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter, Route } from "react-router-dom"
import { CookiesProvider } from "react-cookie"

import Helpdesk from "../../client/src/Helpdesk"

const container = document.getElementById("app")

const root = createRoot(container)

root.render(
  <CookiesProvider>
    <BrowserRouter>
      <Route path="/" render={() => <Helpdesk />} />
    </BrowserRouter>
  </CookiesProvider>
)
